import fetch from '../utils/fetch';

const BOARDS_BASE = process.env.BOARDS_API;

export default {
  getTagboards(id) {
    return fetch(`${BOARDS_BASE}/tagboards/${id}`);
  },
};
